<div class="highlight-conditions" *ngIf="highlightedConditions.length > 0">
  <span class="condition" [conditionHighlight]="entityCondition"
    *ngFor="let entityCondition of highlightedConditions"
    [ngClass]="{'apply' : settingsManager.settings.applyConditions && settingsManager.settings.activeApplyConditions && !entityCondition.expired && settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) == -1 && entityCondition.types.indexOf(ConditionType.apply) != -1, 'double': entityCondition.types.indexOf(ConditionType.double) != -1}">

    <a class="close" [conditionHighlight]="entityCondition"
      *ngIf="settingsManager.settings.applyConditions && settingsManager.settings.activeApplyConditions && !entityCondition.expired && settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) == -1 && entityCondition.types.indexOf(ConditionType.apply) != -1"
      ghs-pointer-input (singleClick)="declineApplyCondition(entityCondition.name, $event)">
      <img class="ghs-svg" src="./assets/images/close_dialog.svg" />
    </a>

    <span class="condition-image">
      <img
        [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + entityCondition.name + '.svg'" />
      <span class="value"
        *ngIf="entityCondition.types.indexOf(ConditionType.value) != -1">{{entityCondition.value}}</span>
    </span>

    <a class="double" [conditionHighlight]="entityCondition"
      *ngIf="settingsManager.settings.applyConditions && settingsManager.settings.activeApplyConditions && !entityCondition.expired && settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) == -1 &&  entityCondition.types.indexOf(ConditionType.apply) != -1 && entityCondition.types.indexOf(ConditionType.double) != -1"
      ghs-pointer-input (singleClick)="applyCondition(entityCondition.name, $event, true)">
      <img
        [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') +  '/attackmodifier/icons/double.png'" />
    </a>

    <a class="check" [conditionHighlight]="entityCondition"
      *ngIf="settingsManager.settings.applyConditions && settingsManager.settings.activeApplyConditions && !entityCondition.expired && settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) == -1 && entityCondition.types.indexOf(ConditionType.apply) != -1"
      ghs-pointer-input (singleClick)="applyCondition(entityCondition.name, $event)">
      <img class="ghs-svg" src="./assets/images/check.svg" />
    </a>
  </span>
</div>